import {
  Col,
  FormGroup,
  Label,
  Row,
  InputGroup,
  Card,
  CardTitle,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import CustomSelect from "../../Common/CustomSelect";
import CheckboxCollapse from '../../Common/CheckboxCollapse';
import { AvField } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../CustomMultipleDateRange/CustomMultipleDateRange";

const InvoiceByOffer = ({
  contractors,
  offers,
  isFormSubmit,
  offers_loading,
  legal_entity,
  legal_entity_loader,
  getOffersByContract,
  contractOffers,
  contractOffersLoader,
  choices
}) => {
  const [selectedClient, setSelectedClient] = React.useState("");
  const [selectedEntity, setSelectedEntity] = React.useState(null);
  const [selectedOffer, setSelectedOffer] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState({
    from: "",
    to: "",
  });
  const [selectedCurrency, setSelectedCurrency] = React.useState("");

  const [isVoucher, setIsVoucher] = React.useState(false);
  const [isVoucherCurrency, setIsVoucherCurrency] = React.useState(false);

  React.useEffect(() => {
    if (selectedDate.from && selectedDate.to) {
      getOffersByContract({
        contract: selectedClient?.value,
        date_from: selectedDate.from,
        date_to: selectedDate.to,
      })
    }
  }, [selectedDate])

  // React.useEffect(() => {
  //   if (selectedOffer === null || selectedOffer?.length === 0) {
  //     setSelectedEntity(null);
  //     setSelectedDate({
  //       from: "",
  //       to: "",
  //     });
  //   }
  // }, [selectedOffer]);

  React.useEffect(() => {
    setSelectedOffer(null);
    if (selectedDate.from && selectedDate.to) {
      getOffersByContract({
        contract: selectedClient?.value,
        date_from: selectedDate.from,
        date_to: selectedDate.to,
      })
    }
  }, [selectedClient]);

  const offers_options = React.useMemo(
    () =>
      contractOffers.map(item => ({
        label: item.name,
        value: item.id,
        // value: item?.inner_contractor?.id
      })),
    [contractOffers]
  );

  const client_options = React.useMemo(
    () =>
      contractors?.results.map(item => ({
        label: item?.counterparty_name + ' ' + `[ ${item?.date_of_signature} ]`,
        value: item?.id,
        // value: item?.inner_contractor?.id
      })),
    [contractors]
  );

  const choicesArray = (choice_type, doubleKey) => {
    let arr = [];
    if (choice_type !== undefined) {
      for (let [key, value] of Object.entries(choice_type)) {
        arr.push({
          label: doubleKey ? key : value,
          value: key,
        });
      }
    }
    return arr;
  };

  // const offers_options = React.useMemo(
  //   () =>
  //     offers?.results
  //       .filter(i => i.contract === selectedClient?.value)
  //       .map(item => ({ label: item.name, value: item.id })),
  //   [selectedClient]
  // );

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">Client</CardTitle>
          <Row>
            <Col sm={12} lg={6} xl={4}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Client:</Label>
                <CustomSelect
                  name={"client"}
                  options={client_options}
                  placeholder="Select client..."
                  defaultValue={selectedClient || ""}
                  onChange={setSelectedClient}
                  required
                  classNamePrefix="select2-selection"
                  errorMessage="Client is required!"
                  isFormSubmit={isFormSubmit}
                />
              </FormGroup>
            </Col>
            {selectedClient && (
              <Col sm={12} lg={12} xl={8}>
                <Row className="fade-in-custom-animate">
                  <Col sm={12} lg={6}>
                    <PickerStyled>
                      <Label htmlFor="">Date from:</Label>
                      <FormGroup className="mb-3">
                        <CustomMultipleDateRange
                          name={`date_from`}
                          placeholder="Select date from..."
                          datePickerType={"calendar"}
                          onChange={date => setSelectedDate({
                            ...selectedDate,
                            from: date.start_date,
                          })}
                          required
                          errorText="Date is required!"
                        />
                      </FormGroup>
                    </PickerStyled>
                  </Col>
                  <Col sm={12} lg={6}>
                    <PickerStyled>
                      <Label htmlFor="">Date to:</Label>
                      <FormGroup className="mb-3">
                        <CustomMultipleDateRange
                          placeholder="Select date to..."
                          name="date_to"
                          datePickerType={"calendar"}
                          onChange={date => setSelectedDate({
                            ...selectedDate,
                            to: date.start_date,
                          })}
                          errorText="Date to is required!"
                          required
                        />
                      </FormGroup>
                    </PickerStyled>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          {/* {selectedEntity?.value && ( */}
          {selectedClient && (
            <Row className="fade-in-custom-animate">
              {selectedDate?.from && selectedDate?.to && (
                <>
                  <Col xl={6} className="fade-in-custom-animate">
                    <FormGroup className="mb-3">
                      <Label htmlFor="">
                        Offer
                        <span className="text-muted" style={{ fontSize: "10px" }}>
                          (optional)
                        </span>
                        :
                        <StyledIcon
                          className="dripicons-question"
                          id="offer-select"
                        />
                        <UncontrolledTooltip
                          placement="right"
                          autohide={false}
                          target="offer-select"
                        >
                          If you don{"'"}t select anything, all offers will be
                          collected.
                        </UncontrolledTooltip>
                      </Label>
                      <CustomSelect
                        name={"offer_ids"}
                        options={offers_options}
                        placeholder="Select offer..."
                        defaultValue={selectedOffer}
                        onChange={setSelectedOffer}
                        classNamePrefix="select2-selection"
                        errorMessage="Offer is required!"
                        isLoading={contractOffersLoader}
                        isFormSubmit={isFormSubmit}
                        isMulti
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-3">
                      <CheckboxCollapse
                        id={"voucher-value"}
                        title="Voucher"
                        defaultChecked={isVoucher}
                        onChange={() => setIsVoucher(!isVoucher)}
                        style={{
                          marginBottom: 14,
                        }}
                      >
                        {isVoucher && (
                          <AvField
                            name={"voucher"}
                            placeholder="Enter voucher name..."
                            type="text"
                            value={""}
                            className="form-control"
                            validate={{
                              required: {
                                value: false,
                              },
                            }}
                          />
                        )}
                      </CheckboxCollapse>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-3">
                      <CheckboxCollapse
                        id={"voucher-currency-value"}
                        title="Currency"
                        defaultChecked={isVoucherCurrency}
                        onChange={() => setIsVoucherCurrency(!isVoucherCurrency)}
                        style={{
                          marginBottom: 14,
                        }}
                      >
                        {isVoucherCurrency && (
                          <Row>
                            <Col sm={6}>
                              <AvField
                                name={`currency_value`}
                                placeholder="Currency value..."
                                type="number"
                                className="form-control"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please, enter a value",
                                  },
                                }}
                              />
                            </Col>
                            <Col sm={6}>
                              <CustomSelect
                                name="currency"
                                options={choicesArray(choices?.currency, true)}
                                placeholder="Currency..."
                                classNamePrefix="select2-selection"
                                isFormSubmit={isFormSubmit}
                                errorMessage="Currency field is required"
                                defaultValue={selectedCurrency}
                                onChange={setSelectedCurrency}
                                required
                              />
                            </Col>
                          </Row>
                        )}
                      </CheckboxCollapse>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }

`;

const StyledIcon = styled.i`
  //vertical-align: middle;
  margin-left: 5px;
  vertical-align: -2.5px;
  color: #5580ff;
`;

InvoiceByOffer.propTypes = {
  offers: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  contractors: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  legal_entity: PropTypes.arrayOf(PropTypes.object).isRequired,
  offers_loading: PropTypes.bool.isRequired,
  isFormSubmit: PropTypes.bool.isRequired,
  legal_entity_loader: PropTypes.bool.isRequired,
  getOffersByContract: PropTypes.func.isRequired,
  contractOffers: PropTypes.arrayOf(PropTypes.object),
  contractOffersLoader: PropTypes.boolean,
  choices: PropTypes.object.isRequired,
};

export default InvoiceByOffer;
